"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Campaign() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  return <section data-section-id="16150" id="campaign-cta" className="bg-background text-foreground relative overflow-hidden py-28 md:py-36 px-6 md:px-12">
      {}
      <div className="absolute top-0 left-0 right-0 pointer-events-none -translate-y-px">
        <svg viewBox="0 0 1440 40" preserveAspectRatio="none" className="w-full h-8 md:h-10" aria-hidden="true">
          <path d="M0,20 C60,8 120,32 180,18 C240,4 300,28 360,16 C420,4 480,30 540,20 C600,10 660,32 720,18 C780,4 840,28 900,16 C960,4 1020,30 1080,22 C1140,12 1200,34 1260,20 C1320,8 1380,28 1440,18 L1440,0 L0,0 Z" fill="hsl(0 0% 98%)" />
        </svg>
      </div>

      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.04] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' seed='4'/></filter><rect width='100%' height='100%' filter='url(%23n)' opacity='1'/></svg>\")"
    }} aria-hidden="true" />

      <div className="relative mx-auto max-w-[760px]">
        <div ref={ref} className="relative">
          {}
          <svg viewBox="0 0 760 440" preserveAspectRatio="none" className="absolute inset-0 w-full h-full pointer-events-none" aria-hidden="true">
            <path d="M 30,18 Q 80,14 140,16 Q 220,19 320,16 Q 420,13 520,17 Q 620,20 700,16 Q 738,15 742,52 Q 745,120 743,200 Q 741,280 744,360 Q 745,400 718,418 Q 660,425 560,422 Q 460,419 360,423 Q 260,427 160,422 Q 80,418 38,420 Q 16,418 16,388 Q 14,300 17,220 Q 20,140 16,60 Q 15,28 30,18 Z" fill="none" stroke="var(--chart-1)" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" className="md:[stroke-width:1.75]" style={{
            strokeDasharray: 2400,
            strokeDashoffset: isVisible ? 0 : 2400,
            transition: "stroke-dashoffset 900ms ease-out"
          }} />
          </svg>

          {}
          <div className="relative px-8 py-12 md:px-16 md:py-20 text-center">
            {}
            <p className="font-mono text-lg md:text-xl mb-6" style={{
            color: "var(--chart-1)"
          }}>
              {"enrollment is now open —"}
            </p>

            {}
            <h2 className="font-default font-bold text-foreground leading-[1.08] tracking-tight mb-6" style={{
            fontSize: "clamp(2rem, 4.4vw, 3.5rem)"
          }}>
              <span>Start your </span>
              <span className="relative inline-block">
                <span className="font-default italic" style={{
                color: "var(--chart-1)",
                fontSize: "1.1em",
                lineHeight: 1
              }}>
                  journey
                </span>
                <svg viewBox="0 0 140 14" preserveAspectRatio="none" className="absolute left-0 right-0 -bottom-2 w-full h-3" aria-hidden="true">
                  <path d="M 4,8 Q 30,3 60,7 Q 90,11 118,5 Q 130,3 136,7" fill="none" stroke="var(--chart-1)" strokeWidth="2" strokeLinecap="round" style={{
                  strokeDasharray: 160,
                  strokeDashoffset: isVisible ? 0 : 160,
                  transition: "stroke-dashoffset 800ms ease-out 600ms"
                }} />
                </svg>
              </span>
              <span>. Build your future.</span>
            </h2>

            {}
            <p className="font-default text-foreground/75 mb-10 max-w-xl mx-auto" style={{
            fontSize: "clamp(1.1rem, 1.15vw, 1.25rem)",
            lineHeight: 1.6
          }}>
              Master new skills with our expert-led programs designed to help you achieve your professional goals this year.
            </p>

            {}
            <Button asChild size="lg" className="group relative rounded-lg h-auto px-7 py-3.5 bg-[var(--chart-1)] text-background hover:bg-[var(--chart-1)]/90 font-default font-semibold text-base shadow-md">
              <Link to="#">
                <span className="relative inline-block">
                  Explore our programs
                  <svg viewBox="0 0 180 8" preserveAspectRatio="none" className="absolute left-0 right-0 -bottom-1.5 w-full h-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200" aria-hidden="true">
                    <path d="M 4,5 Q 45,2 90,4 Q 135,6 176,3" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" className="[stroke-dasharray:180] [stroke-dashoffset:180] group-hover:[stroke-dashoffset:0] transition-[stroke-dashoffset] duration-[220ms] ease-out" />
                  </svg>
                </span>
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}